export function escapeHtml(text) {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return String(text).replace(/[&<>"']/g, (m) => map[m]);
}

export function getStructureClass(client) {
  const clientLower = client.toLowerCase();
  if (clientLower.includes('interne') || clientLower.includes('lillybelle') || clientLower.includes('france')) {
    return 'struct-lilly';
  }
  if (clientLower.includes('togo')) return 'struct-togo';
  if (clientLower.includes('senegal') || clientLower.includes('sénégal')) return 'struct-senegal';
  if (clientLower.includes('burkina') || clientLower.includes('enea')) return 'struct-enea';
  return 'struct-neutral';
}

const STRUCTURE_MAP = {
  LILLYBELLE_H: { name: 'Lillybelle Group', class: 'badge-holding' },
  LILLYBELLE: { name: 'Lillybelle France', class: 'badge-lilly' },
  LILLYBELLE_TOGO: { name: 'Lillybelle Togo', class: 'badge-togo' },
  LILLYBELLE_SENEGAL: { name: 'Lillybelle Sénégal', class: 'badge-senegal' },
  LILLYBELLE_BURKINA: { name: 'Lillybelle Burkina', class: 'badge-enea' },
  ENEA_TELECOM: { name: 'ENEA TELECOM', class: 'badge-enea' }
};

export function getStructureBadge(structureId) {
  const struct = STRUCTURE_MAP[structureId] || { name: structureId, class: 'badge-lilly' };
  return `<span class="struct-badge ${struct.class}">${struct.name}</span>`;
}

export const STRUCTURE_OPTIONS = [
  { id: '', label: 'Toutes structures', dot: '#A09D96', countId: 'cnt-all' },
  { id: 'LILLYBELLE_H', label: 'Lillybelle H', dot: 'var(--holding)', countId: 'cnt-group' },
  { id: 'LILLYBELLE', label: 'Lillybelle France', dot: 'var(--lilly)', countId: 'cnt-france' },
  { id: 'LILLYBELLE_TOGO', label: 'Lillybelle Togo', dot: 'var(--togo)', countId: 'cnt-togo' },
  { id: 'LILLYBELLE_SENEGAL', label: 'Lillybelle Sénégal', dot: '#0891B2', countId: 'cnt-senegal' },
  { id: 'LILLYBELLE_BURKINA', label: 'Lillybelle Burkina', dot: 'var(--enea)', countId: 'cnt-burkina' }
];

export const STRUCT_CNT_IDS = {
  LILLYBELLE_H: 'cnt-group',
  LILLYBELLE: 'cnt-france',
  LILLYBELLE_TOGO: 'cnt-togo',
  LILLYBELLE_SENEGAL: 'cnt-senegal',
  LILLYBELLE_BURKINA: 'cnt-burkina'
};
